<template>
  <div class="pv">
    <div class="pv__agent-head">
      <span class="pv__agent-orb" :class="{ 'pv__agent-orb--spin': run && step < tasks.length }">⚙</span>
      <span class="pv__agent-status">AI AGENT {{ run && step < tasks.length ? '运行中' : '就绪' }}</span>
      <span v-if="step > 0" class="pv__agent-count">{{ Math.min(step, tasks.length) }}/{{ tasks.length }}</span>
    </div>
    <div class="pv__agent-list">
      <div
        v-for="(task, i) in tasks"
        :key="task"
        class="pv__agent-item"
        :class="{
          'pv__agent-item--done': i < step,
          'pv__agent-item--active': i === step && run && step < tasks.length
        }"
        :style="{ opacity: i > step ? 0.35 : 1 }"
      >
        <span class="pv__agent-dot" :class="{ 'pv__agent-dot--done': i < step, 'pv__agent-dot--active': i === step && run && step < tasks.length }">
          {{ i < step ? '✓' : (i === step && run && step < tasks.length ? '⚡' : '·') }}
        </span>
        <span class="pv__agent-name" :class="{ 'pv__agent-name--done': i < step, 'pv__agent-name--active': i === step && run && step < tasks.length }">{{ task }}</span>
        <span v-if="i < step" class="pv__agent-done-tag">完成</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrevAgent',
  props: { run: { type: Boolean, default: false } },
  data() {
    return { step: 0, timer: null, tasks: ['分析店铺数据', '识别爆款商品', '批量优化标题', '更新商品主图', '同步至各平台'] }
  },
  watch: {
    run(v) {
      if (this.timer) clearInterval(this.timer)
      if (!v) { this.step = 0; return }
      this.timer = setInterval(() => {
        this.step = Math.min(this.step + 1, this.tasks.length)
        if (this.step >= this.tasks.length) clearInterval(this.timer)
      }, 700)
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.pv { width: 100%; }
.pv__agent-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(212, 169, 70, .08);
  border: 1px solid rgba(212, 169, 70, .3);
}
.pv__agent-orb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(212, 169, 70, .2);
  border: 1px solid rgba(212, 169, 70, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}
.pv__agent-orb--spin { animation: gx-agentSpin 2s linear infinite; }
.pv__agent-status {
  font-family: Inter, monospace;
  font-size: 10px;
  color: #D4A946;
  letter-spacing: 1px;
  flex: 1;
}
.pv__agent-count { font-size: 9px; color: #4CAF7A; }
.pv__agent-list { display: flex; flex-direction: column; gap: 5px; }
.pv__agent-item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, .03);
  border: 1px solid rgba(255, 255, 255, .06);
  transition: all .3s;
}
.pv__agent-item--done { background: rgba(76, 175, 122, .08); border-color: rgba(76, 175, 122, .3); }
.pv__agent-item--active { background: rgba(212, 169, 70, .08); border-color: rgba(212, 169, 70, .3); }
.pv__agent-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  flex-shrink: 0;
  background: rgba(255, 255, 255, .05);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  color: #D4A946;
}
.pv__agent-dot--done { background: rgba(76, 175, 122, .2); color: #4CAF7A; }
.pv__agent-dot--active { background: rgba(212, 169, 70, .2); color: #D4A946; }
.pv__agent-name { font-size: 11px; flex: 1; color: rgba(220, 215, 240, .4); transition: color .3s; }
.pv__agent-name--done { color: #4CAF7A; }
.pv__agent-name--active { color: #D4A946; }
.pv__agent-done-tag { font-size: 9px; color: rgba(76, 175, 122, .7); }
</style>
